import { createSlice } from '@reduxjs/toolkit';

import app from 'app/config/app';
import isEmpty from 'helpers/isEmpty';
import Response from 'app/config/Response';

const initialState = {
  index: {
    data: [],
    params: {
      limit: app.perPage || 10,
      page: 1,
      sort_by: 'created_ts',
      order_by: 'desc',
    },
    isLoading: false,
    totalCount: 0,
    totalPage: 0,
    isError: false,
    errorCode: null,
    errorMessage: null,
  },
  show: {
    showBriefDetailModal: false,
    finmoPayoutId: null,
    isLoading: false,
    isError: false,
    errorCode: null,
    errorMessage: null,
    data: null,
  },
};

export const finmoPayoutSlice = createSlice({
  name: 'finmoPayouts',
  initialState,
  reducers: {
    getFinmoPayoutsInit: (state) => {
      state.index = {
        ...state.index,
        isLoading: true,
        isError: false,
        errorCode: null,
        errorMessage: null,
      };
    },

    getFinmoPayoutsSuccess: (state, { payload }) => {
      let data = payload?.data ?? [];

      // let { data, pagination } = payload;

      // const { totalCount, totalPage, currentPage, pageSize } = pagination;

      // let startSN = (currentPage - 1) * pageSize;

      let startSN = (state.index.params.page - 1) * state.index.params.limit;

      data = data?.map((item) => ({ sn: (startSN += 1), ...item }));

      state.index = {
        ...state.index,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data,
        // totalCount,
        // totalPage,
      };
    },

    getFinmoPayoutsFailure: (state, { payload }) => {
      state.index = {
        ...state.index,
        isLoading: false,
        isError: true,
        errorCode: payload?.response?.status ?? 0,
        errorMessage: payload?.response?.message,
      };
    },

    resetGetFinmoPayoutsFailure: (state) => {
      state.index = {
        ...state.index,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
      };
    },

    setParam: (state, { payload }) => {
      state.index.params = { ...state.index.params, ...payload };
    },

    resetParam: (state) => {
      state.index.params = {
        page_size: state.index.params.page_size,
        page_number: 1,
      };
    },

    deleteFilterParams: (state, { payload }) => {
      if (Array.isArray(payload)) payload.forEach((key) => delete state.index.params[key]);
      else delete state.index.params[payload];
    },

    getFinmoPayoutInit: (state) => {
      state.show = {
        ...state.show,
        isLoading: true,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: null,
      };
    },

    getFinmoPayoutSuccess: (state, { payload }) => {
      const data = payload?.data;
      if (isEmpty(data)) {
        state.show = {
          ...state.show,
          isLoading: false,
          isError: true,
          errorCode: Response.HTTP_NOT_FOUND,
          errorMessage: 'Finmo Payout not found',
        };
      } else {
        state.show = {
          ...state.show,
          isLoading: false,
          isError: false,
          errorCode: null,
          errorMessage: null,
          data,
        };
      }
    },

    getFinmoPayoutFailure: (state, { payload }) => {
      state.show = {
        ...state.show,
        isLoading: false,
        isError: true,
        errorCode: payload?.response?.status ?? 0,
        errorMessage: payload?.response?.message,
        data: null,
      };
    },

    resetGetFinmoPayoutFailure: (state) => {
      state.show = {
        ...state.show,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: null,
      };
    },

    getFinmoPayoutBriefDetailsInit: (state, { payload }) => {
      state.show = {
        ...state.show,
        showBriefDetailModal: payload.showBriefDetailModal,
        finmoPayoutId: payload.finmoPayoutId,
      };
    },

    hideFinmoPayoutBriefDetails: (state) => {
      state.show = {
        showBriefDetailModal: false,
        finmoPayoutId: null,
        isLoading: false,
        isError: false,
        errorCode: null,
        errorMessage: null,
        data: null,
      };
    },
  },
});

export const {
  getFinmoPayoutsInit,
  getFinmoPayoutsSuccess,
  getFinmoPayoutsFailure,
  resetGetFinmoPayoutsFailure,
  setParam,
  resetParam,
  deleteFilterParams,
  setShowCreateProcessingModal,
  setShowEditProcessingModal,
  getFinmoPayoutInit,
  getFinmoPayoutSuccess,
  getFinmoPayoutFailure,
  resetGetFinmoPayoutFailure,
  getFinmoPayoutBriefDetailsInit,
  hideFinmoPayoutBriefDetails,
} = finmoPayoutSlice.actions;

export default finmoPayoutSlice.reducer;
